import { axiosClient } from "../axios";
import { getQuery } from "../helper";

const baseUrl = "/api/docs/esg-compliant-uploaded-documents";

export function get(enterpriseId, params) {
  const query = getQuery(params);
  return axiosClient.get(`${baseUrl}/${enterpriseId}`, query);
}

export function save(data) {
  return axiosClient.post(`${baseUrl}/save`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function remove(id) {
  return axiosClient.delete(`${baseUrl}/${id}`);
}

export function download(id) {
  const config = {
    responseType: "blob",
  };
  return axiosClient.get(`${baseUrl}/${id}/download`, config);
}
